import * as React from 'react';
import { SignIn } from 'decentraland-ui/dist/components/SignIn/SignIn';
import { T } from '../../modules/translation/utils';
import { isMobile } from '../../lib/utils';
import { isCucumberProvider } from '../../lib/eth';
export default class SignInPage extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    getTranslations = () => {
        const { hasTranslations, isConnected } = this.props;
        if (!hasTranslations) {
            return undefined;
        }
        return {
            header: React.createElement(T, { id: "@dapps.sign_in.get_started" }),
            error: React.createElement(T, { id: "@dapps.sign_in.error" }),
            connect: React.createElement(T, { id: "@dapps.sign_in.connect" }),
            connecting: React.createElement(T, { id: "@dapps.sign_in.connecting" }),
            connected: React.createElement(T, { id: "@dapps.sign_in.connected" }),
            message: isConnected ? (React.createElement(T, { id: "@dapps.sign_in.options.connected" })) : isCucumberProvider() ? (React.createElement(T, { id: "@dapps.sign_in.options.samsung", values: {
                    samsung_link: (React.createElement("a", { href: "https://www.samsung.com/global/galaxy/apps/samsung-blockchain/", target: "_blank", rel: "noopener noreferrer" }, "Samsung Blockchain Wallet"))
                } })) : isMobile() ? (React.createElement(T, { id: "@dapps.sign_in.options.mobile", values: {
                    metamask_link: (React.createElement("a", { href: "https://metamask.io", target: "_blank", rel: "noopener noreferrer" }, "MetaMask")),
                    coinbase_link: (React.createElement("a", { href: "https://wallet.coinbase.com", target: "_blank", rel: "noopener noreferrer" }, "Coinbase Wallet")),
                    imtoken_link: (React.createElement("a", { href: "https://token.im", target: "_blank", rel: "noopener noreferrer" }, "imToken"))
                } })) : (React.createElement(T, { id: "@dapps.sign_in.options.desktop", values: {
                    metamask_link: (React.createElement("a", { href: "https://metamask.io", target: "_blank", rel: "noopener noreferrer" }, "MetaMask")),
                    ledger_nano_link: (React.createElement("a", { href: "https://www.ledger.com/", target: "_blank", rel: "noopener noreferrer" }, "Ledger Nano S"))
                } }))
        };
    };
    render() {
        const { center, isConnected, isConnecting, hasError, onConnect } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement(SignIn, { center: center, isConnected: isConnected, isConnecting: isConnecting, hasError: hasError, onConnect: onConnect, i18n: this.getTranslations() })));
    }
}
//# sourceMappingURL=SignInPage.js.map